import pcConsoleTopCharts from './pcConsoleTopCharts';
import MarketProfilMobile from './MarketProfilMobile';
export default {
  ...pcConsoleTopCharts,
  ...MarketProfilMobile,
} as any;
